import { Card, Col, Form, Offcanvas, Row } from "react-bootstrap";
import { apiCall } from "../../utils/axiosService";
import { API_URL } from "../../utils/apiRoutes";
import React, { useEffect, useRef, useState } from "react";
import { } from /* useNavigate */ "react-router-dom";
import Loader from "../Loader/Loader";
import Skeleton from "../Skeletons/Skeleton";
import { commonService } from "../../utils/commonService";
import { useDispatch, useSelector } from "react-redux";
import { setAllNotificationCount } from "../../utils/slices/headerPropertySlice";
import { apiResponse } from "../../utils/apiResponse";

const NotificationList = ({ showSideBar, closeSideBar }) => {
    const notificationType = useSelector(
        (store) => store.headerProperty.allNotificationCount,
    );
    const allPropertyDetails = useSelector(
        (store) => store.headerProperty.allPropertyDetails,
    );
    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail,
    );
    const dispatch = useDispatch();

    const [notificationList, setNotificationList] = useState([]);
    const [start, setstart] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const PAGE_SIZE = 10;
    const [loading, setLoading] = useState(false);
    const [input, setInput] = useState("");
    const userDetail = commonService.getLoginUserData();
    // const [activeAccrodian, setActiveAccrodian] = useState(null);
    const [selectedProperty, setSelectedProperty] = useState(
        propertyDetailFromRTK,
    );

    const getNotificationList = async ({
        prop = selectedProperty,
        pageStart = start,
    } = {}) => {
        if (loading || (!hasMore && pageStart > 0)) return;
        setLoading(true);
        let notificationListResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.Notification + API_URL.NOTIFICATION.GET_LIST,
                body: {
                    title: input,
                    notificationstartdate: "",
                    notificationenddate: "",
                    notificationtoid: "",
                    draw: 1,
                    start: pageStart,
                    length: PAGE_SIZE,
                    sortcolumn: "notificationid",
                    sortdirection: "desc",
                    searchvalue: "",
                    columns: "",
                    "search.value": "",
                    "search.regex": "",
                    order: "",
                    associationtype: "", // activeAccrodian,
                },
            },
            true,
        );

        if (notificationListResponse?.status_code === 0) {
        } else if (notificationListResponse?.status_code === 1) {
            const data = notificationListResponse?.data || [];
            if (pageStart === 0) setNotificationList(data);
            else setNotificationList((prev) => [...prev, ...data]);
            setHasMore(data.length === PAGE_SIZE);
        } else if (notificationListResponse?.status_code === 2) {
            commonService.LogOutToUser();
        }
        setLoading(false);
    };

    const getInsightList = async ({
        prop = selectedProperty,
        pageStart = start,
    } = {}) => {
        if (loading || (!hasMore && pageStart > 0)) return;
        setLoading(true);
        let getInsightLiastResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.Notification +
                    API_URL.NOTIFICATION.GET_INSIGHT_LIST,
                body: {
                    title: "",
                    notificationstartdate: "",
                    notificationenddate: "",
                    notificationtoid: "",
                    propertycode: prop ? prop?.propertycode : "",
                    draw: 1,
                    start: pageStart,
                    length: PAGE_SIZE,
                    sortcolumn: "notificationid",
                    sortdirection: "desc",
                    searchvalue: "",
                    columns: "",
                    "search.value": "",
                    "search.regex": "",
                    order: "",
                    associationtype: "", //activeAccrodian,
                },
            },
            true,
        );

        if (getInsightLiastResponse?.status_code === 0) {
        } else if (getInsightLiastResponse?.status_code === 1) {
            const data = getInsightLiastResponse?.data || [];
            if (pageStart === 0) setNotificationList(data);
            else setNotificationList((prev) => [...prev, ...data]);
            setHasMore(data.length === PAGE_SIZE);
        } else if (getInsightLiastResponse?.status_code === 2) {
            commonService.LogOutToUser();
        }
        setLoading(false);
    };

    const containerRef = useRef(null);

    useEffect(() => {
        const el = containerRef.current;
        if (!el) return;

        const onScroll = () => {
            const scrollTop = el.scrollTop;
            const scrollHeight = el.scrollHeight;
            const clientHeight = el.clientHeight;
            const threshold = 50; // px from bottom

            if (scrollTop + clientHeight >= scrollHeight - threshold) {
                if (!loading && hasMore) {
                    setstart((prev) => prev + PAGE_SIZE);
                }
            }
        };

        el.addEventListener("scroll", onScroll, { passive: true });
        return () => el.removeEventListener("scroll", onScroll);
    }, [loading, hasMore]);

    // when filter/context changes, reset list and paging first
    useEffect(() => {
        setNotificationList([]);
        setstart(0);
        setHasMore(true);
        getNotificationCount();
    }, [selectedProperty]);

    useEffect(() => {
        if (!hasMore && start > 0) return; // no more to load

        if (selectedProperty) {
            getInsightList();
        } else {
            getNotificationList();
        }
    }, [start, selectedProperty]);

    const getNotificationCount = async () => {
        let notificationCountResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.Notification +
                    API_URL.NOTIFICATION.GET_NOTIFICATION_READ_COUNT,
                body: {
                    propertycode: selectedProperty ? selectedProperty?.propertycode : "",
                },
            },
            true,
        );

        let response = apiResponse(false, notificationCountResponse);

        if (response?.isValidate) {
            dispatch(setAllNotificationCount(response?.data?.data));
        }
    };

    const updateNotificationView = async (id) => {
        let notificationUpdateResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.Notification +
                    API_URL.NOTIFICATION.UPDATE_VIEW_BY,
                body: {
                    notificationbyid: id,
                    userid: userDetail?.userid,
                },
            },
            true,
        );

        let response = apiResponse(false, notificationUpdateResponse);

        if (response?.isValidate) {
            getNotificationCount();
        }
    };

    const isElementVisible = () => {
        notificationList?.forEach((item) => {
            let ele = document.getElementById(`${item?.notificationid}`);
            const rect = ele.getBoundingClientRect();

            if (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <=
                (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <=
                (window.innerWidth || document.documentElement.clientWidth) &&
                item?.isread === false
            ) {
                updateNotificationView(item?.notificationid);
            }
        });
    };

    useEffect(() => {
        isElementVisible();
    }, [notificationList]);

    useEffect(() => {
        setNotificationList([]);
        setstart(0);
        setHasMore(true);
        getNotificationCount();
    }, [selectedProperty]);

    const isHTML = (str) => {
        const doc = new DOMParser().parseFromString(str, 'text/html');
        // Checks if the string parsed into actual elements rather than just text
        return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
    };

    return (
        <Offcanvas
            className="notification-canvas"
            show={showSideBar}
            onHide={closeSideBar}
            placement="end"
        >
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Notification List</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="d-flex justify-content-center">
                <Col xl={12} className="w-75">
                    {
                        allPropertyDetails && allPropertyDetails.length > 0 &&
                        <div className="from-groups no-border-break mb-3">
                            <Form.Select
                                id={commonService.generateGlobalClickTrackerID(
                                    "NotificationList",
                                    "form-select-onchange",
                                    "",
                                )}
                                aria-label="Default select example"
                                value={selectedProperty?.propertyid}
                                onChange={(e) => {
                                    // compute new property synchronously and trigger immediate fetch
                                    let newProp = null;
                                    if (e.target.value === "") {
                                        newProp = "";
                                    } else {
                                        newProp = allPropertyDetails?.find(
                                            (x) => x?.propertyid == e.target.value,
                                        );
                                    }
                                    // update selection state
                                    setSelectedProperty(newProp);
                                    // reset paging and list
                                    setNotificationList([]);
                                    setstart(0);
                                    setHasMore(true);
                                    // call appropriate API immediately for page 0 using newProp
                                    if (newProp) {
                                        getInsightList({ prop: newProp, pageStart: 0 });
                                    } else {
                                        getNotificationList({ prop: null, pageStart: 0 });
                                    }
                                }}
                            >
                                <option value="">Select Property</option>
                                {allPropertyDetails?.map((item) => {
                                    return (
                                        <option key={item?.propertyid} value={item?.propertyid}>
                                            {item?.propertyname}
                                        </option>
                                    );
                                })}
                            </Form.Select>
                        </div>

                    }

                    <div className="insightsAccordion">
                        <div>
                            <Row
                                style={{
                                    maxHeight: "85vh",
                                    overflowY: "auto",
                                    margin: 0
                                }}
                                className="w-100"
                                ref={containerRef}
                            >
                                {notificationList?.length > 0 ? (
                                    notificationList?.map((notificationData, index) => {
                                        let notificationTime = "";
                                        if (
                                            commonService.getDateInFormat(
                                                new Date(new Date().toUTCString()),
                                            ) ===
                                            commonService.getDateInFormat(
                                                notificationData?.notificationdatetime,
                                            )
                                        ) {
                                            let dif =
                                                new Date(
                                                    new Date().getUTCFullYear(),
                                                    new Date().getUTCMonth(),
                                                    new Date().getUTCDate(),
                                                    new Date().getUTCHours(),
                                                    new Date().getUTCMinutes(),
                                                ) - new Date(notificationData?.notificationdatetime);
                                            let totalMinutes = Math.round(dif / 1000 / 60);
                                            if (totalMinutes > 59) {
                                                notificationTime =
                                                    Math.round(totalMinutes / 60) + " hours ago";
                                            } else {
                                                if (totalMinutes > 0) {
                                                    notificationTime = totalMinutes + " min ago";
                                                } else {
                                                    notificationTime = "sec ago";
                                                }
                                            }
                                        } else {
                                            notificationTime = commonService.getDateInFormat(
                                                notificationData?.notificationdatetime,
                                            );
                                        }

                                        let notificationDetail = notificationData?.details;
                                        let title = notificationData?.title?.split("]:");
                                        const propertyColor = commonService.getColorByCategory(
                                            selectedProperty?.propertycode ?? "-",
                                        );
                                        const categoryColor = commonService.getColorByCategory(
                                            notificationData?.category ?? "-",
                                        );
                                        const associationColor = commonService.getColorByCategory(
                                            notificationData?.associationtype ?? "-",
                                        );

                                        const isBookingCurve = notificationData?.associationtype === "Booking Curve";
                                        const shouldStretch = !!notificationData?.details;

                                        return (
                                            <Col xl={6} lg={6} md={6} sm={12} className={`mb-3 ${shouldStretch ? 'd-flex flex-column' : ''}`}>
                                                <div className={`notification-card ${shouldStretch ? 'flex-grow-1 d-flex flex-column' : ''} ${isBookingCurve ? 'booking-curve-card' : ''}`}>
                                                    <Card id={notificationData?.notificationid} className={`border-0 ${shouldStretch ? "stretch-card" : ""}`}>
                                                        <div
                                                            className={`notificationMain ${notificationData?.isread === false
                                                                ? "unreadnotification"
                                                                : ""
                                                                } `}
                                                            id={notificationData?.notificationid}
                                                        >
                                                            {/* <div className="notification-wrapper"> */}
                                                            <Card.Header className="p-1">
                                                                <div className="d-flex justify-content-between notification-name-time p-1">
                                                                    <div className="notification-name d-flex align-items-center gap-1 flex-wrap">
                                                                        {selectedProperty?.propertycode && (
                                                                            <span
                                                                                style={{
                                                                                    background: propertyColor.light,
                                                                                    color: propertyColor.color,
                                                                                    padding: "3px 8px",
                                                                                    borderRadius: "12px",
                                                                                    fontWeight: 600,
                                                                                    fontSize: "0.70rem",
                                                                                    display: "inline-block",
                                                                                }}
                                                                            >
                                                                                {selectedProperty?.propertycode ?? "-"}
                                                                            </span>
                                                                        )}
                                                                        {notificationData?.category && (
                                                                            <span
                                                                                style={{
                                                                                    background: categoryColor.light,
                                                                                    color: categoryColor.color,
                                                                                    padding: "3px 8px",
                                                                                    borderRadius: "12px",
                                                                                    fontWeight: 600,
                                                                                    fontSize: "0.70rem",
                                                                                    display: "inline-block",
                                                                                }}
                                                                            >
                                                                                {notificationData?.category ?? "-"}
                                                                            </span>
                                                                        )}
                                                                        {notificationData?.associationtype && (
                                                                            <span
                                                                                style={{
                                                                                    background: associationColor.light,
                                                                                    color: associationColor.color,
                                                                                    padding: "3px 8px",
                                                                                    borderRadius: "12px",
                                                                                    fontWeight: 600,
                                                                                    fontSize: "0.70rem",
                                                                                    display: "inline-block",
                                                                                }}
                                                                            >
                                                                                {notificationData?.associationtype ?? "-"}
                                                                            </span>
                                                                        )}
                                                                    </div>

                                                                    <p className="notification-date">
                                                                        {notificationTime}
                                                                    </p>
                                                                </div>
                                                            </Card.Header>
                                                            <Card.Body className="pb-0 mb-0">
                                                                <div className="notification-ttile-detail">
                                                                    {isHTML(notificationData?.details) ? (
                                                                        <div
                                                                            className="notification-detail"
                                                                            dangerouslySetInnerHTML={{
                                                                                __html: notificationData?.details,
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <div className="notification-detail">
                                                                            <div className="card s-oth">
                                                                                <div className="card-main">

                                                                                    <h4>{notificationData?.title}</h4>
                                                                                    <div
                                                                                        className="notification-detail"
                                                                                        dangerouslySetInnerHTML={{
                                                                                            __html: notificationData?.details,
                                                                                        }}
                                                                                    />

                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </Card.Body>
                                                            {/* </div> */}
                                                        </div>
                                                    </Card>
                                                </div>
                                            </Col>
                                        );
                                    })
                                ) : (
                                    <></>
                                )}
                                {!loading && notificationList.length === 0 && (
                                    <Col xl={12}>
                                        <Card>
                                            <Card.Body className="m-0 mt-2 mb-2 p-0">
                                                <div className="text-center">No Data Found</div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                )}
                                {loading && (
                                    <Col xl={12}>
                                        <div className="cards-grid">
                                            <Skeleton skeletonType="NotificationList" count={6} />{" "}
                                        </div>
                                    </Col>
                                )}
                            </Row>
                        </div>
                    </div>
                </Col>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default NotificationList;
